import { useState, useEffect, useCallback } from 'react';

/**
 * Hook to manage keyboard hotkeys for the game.
 * Handles hint toggle (CTRL+ALT+S) and auto-solve (CTRL+ALT+W).
 * 
 * @param {boolean} isComplete - Whether the puzzle is complete
 * @param {Function} autoSolve - Function to auto-solve the puzzle
 */
export function useHotkeys(isComplete, autoSolve) {
  const [showHint, setShowHint] = useState(false);

  // Toggle hint display
  const toggleHint = useCallback(() => {
    setShowHint(prev => !prev);
  }, []);

  // Handle hotkey events
  useEffect(() => {
    const handleKeyDown = (e) => {
      // CTRL+ALT+S to toggle hint overlay
      if (e.ctrlKey && e.altKey && e.key.toLowerCase() === 's') {
        e.preventDefault();
        setShowHint(prev => !prev);
      }
      // CTRL+ALT+W to auto-solve puzzle
      if (e.ctrlKey && e.altKey && e.key.toLowerCase() === 'w') {
        e.preventDefault();
        if (!isComplete) {
          autoSolve();
        }
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isComplete, autoSolve]);

  return {
    showHint,
    setShowHint,
    toggleHint
  };
}
